export default __webpack_public_path__ + "static/media/ic_exit.66724896.svg";